import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import axios from "axios";
import getError from "../utils/getError";
import setAuthToken from "../utils/setAuthToken";
import url from "../utils/url";
import { siteInfo } from "../utils/SiteInfo";
import { masterFunction } from "../api/api";

export const loginAdmin = (data, loginAfterFunction) => (dispatch) => {
  axios
    .post(url + "/auth", data)
    .then((res) => {
      const respData = masterFunction(res, false);
      console.log(respData);

      if (respData && respData.success) {
        const { access_token } = respData;
        setAuthToken(access_token);
        localStorage.setItem(siteInfo.sitekey, access_token);
        dispatch(setAuth(true));
        dispatch(saveConfig());
        loginAfterFunction(true);
      }
    })
    .catch((err) => {
      loginAfterFunction(false, getError(err));
    });
};

export const saveConfig = () => (dispatch) => {
  axios
    .get(url + "/config")
    .then((res) => {
      const result = masterFunction(res);
      if (result) {
        localStorage.setItem("config", JSON.stringify(result));
        dispatch(setConfig(result));
        dispatch(setProfile(result?.profile));
      }
    })
    .catch((err) => {});
};
export const saveProfile = () => (dispatch) => {
  axios
    .get(url + "/profile")
    .then((res) => {
      const result = masterFunction(res);
      if (result) {
        let role = result?.role ? result?.role : "";
        dispatch(setProfile(result));
      }
    })
    .catch((err) => {});
};

export const logoutAdmin = (afterFunction) => (dispatch) => {
  localStorage.removeItem(siteInfo.sitekey);
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
export const setAdminProfile = (data) => {
  return {
    type: "SET_ADMIN_PROFILE",
    payload: data,
  };
};

export const setAdminRole = (data) => {
  return {
    type: "SET_ADMIN_ROLES",
    payload: data,
  };
};
